import React from "react";

interface RunAllTestsButtonProps {
  isRunning: boolean;
  onClick: () => void;
}

export const RunAllTestsButton: React.FC<RunAllTestsButtonProps> = ({
  isRunning,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isRunning}
      style={{
        color: "#fff",
        backgroundColor: isRunning ? "#ccc" : "#007bff",
        cursor: isRunning ? "not-allowed" : "pointer",
      }}
    >
      {isRunning ? "Running Tests..." : "Run All Tests"}
    </button>
  );
};

interface OnboardButtonProps {
  mnemonic: string;
  baseURL: string;
  onboardLoading: boolean;
  isRunning: boolean;
  onOnboard: (mnemonic: string, baseURL: string) => void;
}

export const OnboardButton: React.FC<OnboardButtonProps> = ({
  mnemonic,
  baseURL,
  onboardLoading,
  isRunning,
  onOnboard,
}) => {
  const isDisabled =
    onboardLoading || isRunning || !mnemonic || mnemonic.trim() === "";

  return (
    <button
      onClick={() => {
        if (mnemonic && mnemonic.trim() !== "") {
          onOnboard(mnemonic, baseURL);
        }
      }}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#28a745",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {onboardLoading ? "Running Authentication Flow..." : "Authentication Flow"}
    </button>
  );
};

interface ClearResultsButtonProps {
  isRunning: boolean;
  onClick: () => void;
}

export const ClearResultsButton: React.FC<ClearResultsButtonProps> = ({
  isRunning,
  onClick,
}) => {
  return (
    <button
      onClick={onClick}
      disabled={isRunning}
      style={{
        color: isRunning ? "#ccc" : "#fff",
        backgroundColor: isRunning ? "#ccc" : "#dc3545",
        cursor: isRunning ? "not-allowed" : "pointer",
      }}
    >
      Clear Results
    </button>
  );
};

interface UtilityTestButtonProps {
  isRunning: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export const UtilityTestButton: React.FC<UtilityTestButtonProps> = ({
  isRunning,
  isLoading,
  onClick,
}) => {
  const isDisabled = isLoading || isRunning;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#17a2b8",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {isLoading ? "Running Utility Tests..." : "Utility Test"}
    </button>
  );
};

interface InfoClientTestButtonProps {
  isRunning: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export const InfoClientTestButton: React.FC<InfoClientTestButtonProps> = ({
  isRunning,
  isLoading,
  onClick,
}) => {
  const isDisabled = isLoading || isRunning;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#6f42c1",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {isLoading ? "Running Info Client Tests..." : "Info Client Test"}
    </button>
  );
};

interface WalletSpecificTestButtonProps {
  isRunning: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export const WalletSpecificTestButton: React.FC<WalletSpecificTestButtonProps> = ({
  isRunning,
  isLoading,
  onClick,
}) => {
  const isDisabled = isLoading || isRunning;

  return (
    <button
      onClick={onClick}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#fd7e14",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
    >
      {isLoading ? "Running Wallet Specific Tests..." : "Wallet Specific Test"}
    </button>
  );
};

interface ExchangeClientTestButtonProps {
  mnemonic: string;
  isRunning: boolean;
  isLoading: boolean;
  onClick: () => void;
}

export const ExchangeClientTestButton: React.FC<ExchangeClientTestButtonProps> = ({
  mnemonic,
  isRunning,
  isLoading,
  onClick,
}) => {
  const isMnemonicValid = mnemonic && mnemonic.trim() !== "";
  const isDisabled = isLoading || isRunning || !isMnemonicValid;

  return (
    <button
      onClick={() => {
        if (isMnemonicValid) {
          onClick();
        }
      }}
      disabled={isDisabled}
      style={{
        color: isDisabled ? "#ccc" : "#fff",
        backgroundColor: isDisabled ? "#ccc" : "#e83e8c",
        cursor: isDisabled ? "not-allowed" : "pointer",
      }}
      title={!isMnemonicValid ? "Mnemonic is required for Exchange Client tests" : ""}
    >
      {isLoading ? "Running Exchange Client Tests..." : "Exchange Client Test"}
    </button>
  );
};

interface DismissErrorButtonProps {
  onClick: () => void;
}

export const DismissErrorButton: React.FC<DismissErrorButtonProps> = ({
  onClick,
}) => {
  return (
    <button onClick={onClick} className="sdk-test-button-dismiss">
      Dismiss
    </button>
  );
};
